import angular, { ILogService } from 'angular'
import { CandidatoConfig } from '../../../_test/play-candidato-app'

class JsonDataComponentCtrl {
  data!: any

  verFormato = false

  constructor(private $log: ILogService, private $element: JQLite, private CandidatoCfg: CandidatoConfig) {}

  $onInit(): void {
    this.$log.info('[JsonDataComponentCtrl] onInit', this.data)
  }

  toggleFormato() {
    this.verFormato = !this.verFormato
  }
}

angular.module('candidato').component('jsonData', {
  bindings: {
    // empresa: "<",
    data: '<',
  },
  controllerAs: 'ctrl',
  transclude: true,
  controller: JsonDataComponentCtrl,
  template: `<pre class="cursor-pointer text-sm" ng-click="ctrl.toggleFormato()"  ng-if="ctrl.verFormato">{{ ctrl.data | json }}</pre>
 <span class="cursor-pointer text-sm" ng-click="ctrl.toggleFormato()"  ng-if="!ctrl.verFormato">{{ ctrl.data | json }}</span>`,
  //templateUrl: "../../../../app/ui/vs/prog/dev/templates/if-dev/if-dev.component.html"
})
